import { Map, fromJS } from 'immutable'

import { GET_DASH_DATA, SET_VISIBLE, RESET_DASH, DASH_DATA_LOADING } from '../actions'

export const initialState = new Map({
  loaded: false,
  loading: false,
  data: new Map({
    company: new Map(),
    department: new Map(),
    team: new Map()
  }),
  visible: new Map(),
  page: new Map({
    level: 'company',
    levelId: null
  })
})

const adminDashReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case DASH_DATA_LOADING:
      return state.set('loading', action.data)
    case GET_DASH_DATA: {
      const path = ['data', action.level]
      if (action.levelId !== null) path.push(action.levelId)
      return state
        .mergeDeepIn(path, fromJS(action.data))
        .set(
          'page',
          new Map({
            level: action.level,
            levelId: action.levelId
          })
        )
        .set('visible', fromJS(action.data))
        .set('loaded', true)
        .set('loading', false)
    }
    case SET_VISIBLE:
      return state
        .set('page', new Map({ level: action.level, levelId: action.levelId }))
        .set('visible', fromJS(action.data))
        .set('loaded', true)
    case RESET_DASH:
      return state
        .set('visible', new Map())
        .set(
          'page',
          new Map({
            level: 'company',
            levelId: null
          })
        )
        .set('loaded', false)
    default:
      return state
  }
}

export default adminDashReducer
